import React, { PropsWithChildren, ReactNode, useMemo, useState } from 'react';
import upperFirst from 'lodash/upperFirst';
import { useActivatedPromocodesFreePeriod } from '@cp/entities/promocode';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { ClickAwayListener } from '@mui/material';
import { Tooltip } from '@cp/ds/src/components/tooltip';
import { WithPaymentCallback } from 'src/shared/payment';
import { StartSubscriptionLink } from './startSubscriptionLink';

const TooltipContent = (props: BoxProps & PropsWithChildren) => {
  const promocodePeriod = useActivatedPromocodesFreePeriod();
  const freePeriod = useMemo(() => (promocodePeriod ? ` ${upperFirst(promocodePeriod)} - бесплатно` : ''), [promocodePeriod]);
  return (
    <Box sx={{ px: 1.75, py: 1 }} {...props}>
      {props.children}&nbsp;
      <StartSubscriptionLink color="pink" underline>
        оформить подписку.
      </StartSubscriptionLink>
      {freePeriod}
    </Box>
  );
};

export const withSubscriptionTooltip =
  <T extends WithPaymentCallback = {}>(Component: (p: T) => JSX.Element | null) =>
  ({ tooltipText, ...props }: Omit<T, 'onPaymentRequired'> & { tooltipText: ReactNode }) => {
    const [open, setOpen] = useState(false);
    return (
      <Tooltip
        arrow
        colorSchema="dark"
        disableHoverListener
        open={open}
        title={
          <ClickAwayListener onClickAway={(e) => setOpen(false)}>
            <div>
              <TooltipContent onClick={() => setOpen(false)}>{tooltipText}</TooltipContent>
            </div>
          </ClickAwayListener>
        }
      >
        {/* @ts-expect-error infer T */}
        <Component onPaymentRequired={() => setOpen(true)} {...props} />
      </Tooltip>
    );
  };
